import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  AbsenceResponse,
  ActionType,
  BreakfastPayload,
} from "models/dashboard/breakfast";
import { httpStatus } from "configs/httpStatus";
import { fetchBreakfastChart } from "services/dashboard";
import { handleSuccessAction, handleErrorAction } from "./breakfastActions";

function* getBreakfastSaga({ payload }: { payload: BreakfastPayload }) {
  try {
    const response: AbsenceResponse = yield call(fetchBreakfastChart, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetBreakfastWatcher() {
  yield takeLatest(ActionType.GET_BREAKFAST_CHART as any, getBreakfastSaga);
}

export default [fork(onGetBreakfastWatcher)];
